module.exports = __webpack_public_path__ + "static/jobs-website@2x-263884c3c35fd4fbf04b7f0721a058a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/examples/jobs-website@2x.jpg
// module id = 880
// module chunks = 71833740541355 256871573202158